/* Environment Map — Layout computation engines */

function circularLayout(nodes, width, height) {
  var cx = width / 2, cy = height / 2;
  var r = Math.min(width, height) * 0.35;
  return nodes.map(function (n, i) {
    if (n.position_x != null && n.position_y != null) return { x: n.position_x, y: n.position_y };
    var a = (2 * Math.PI * i) / nodes.length - Math.PI / 2;
    return { x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) };
  });
}

function hierarchicalLayout(nodes, edges, nodeIndex, width, height) {
  var inDeg = {};
  var children = {};
  nodes.forEach(function (n) { inDeg[n.node_id] = 0; children[n.node_id] = []; });
  edges.forEach(function (e) {
    if (nodeIndex[e.source_node_id] != null && nodeIndex[e.target_node_id] != null) {
      inDeg[e.target_node_id] = (inDeg[e.target_node_id] || 0) + 1;
      children[e.source_node_id].push(e.target_node_id);
    }
  });
  var levels = {};
  var queue = nodes.filter(function (n) { return (inDeg[n.node_id] || 0) === 0; }).map(function (n) { return n.node_id; });
  var visited = new Set();
  var depth = 0;
  while (queue.length > 0) {
    var nextQ = [];
    queue.forEach(function (nid) {
      if (visited.has(nid)) return;
      visited.add(nid);
      levels[nid] = depth;
      (children[nid] || []).forEach(function (c) { nextQ.push(c); });
    });
    queue = nextQ;
    depth++;
  }
  nodes.forEach(function (n) { if (levels[n.node_id] == null) levels[n.node_id] = depth; });
  var maxLevel = Math.max.apply(null, Object.values(levels).concat([0]));
  var levelCounts = {};
  var levelIdx = {};
  nodes.forEach(function (n) {
    var lv = levels[n.node_id];
    levelCounts[lv] = (levelCounts[lv] || 0) + 1;
    levelIdx[n.node_id] = (levelCounts[lv] - 1);
  });
  return nodes.map(function (n) {
    if (n.position_x != null && n.position_y != null) return { x: n.position_x, y: n.position_y };
    var lv = levels[n.node_id];
    var count = levelCounts[lv] || 1;
    var idx = levelIdx[n.node_id];
    var y = 60 + (lv / Math.max(1, maxLevel)) * (height - 120);
    var x = (width / (count + 1)) * (idx + 1);
    return { x: x, y: y };
  });
}

function manualLayout(nodes, width) {
  return nodes.map(function (n, i) {
    if (n.position_x != null && n.position_y != null) return { x: n.position_x, y: n.position_y };
    var cols = Math.ceil(Math.sqrt(nodes.length));
    var row = Math.floor(i / cols);
    var col = i % cols;
    return { x: 100 + col * 160, y: 80 + row * 100 };
  });
}

function forceLayout(nodes, edges, nodeIndex, width, height) {
  var positions = nodes.map(function (n, i) {
    if (n.position_x != null && n.position_y != null) return { x: n.position_x, y: n.position_y };
    var a = (2 * Math.PI * i) / nodes.length;
    var r = Math.min(width, height) * 0.3;
    return { x: width / 2 + r * Math.cos(a), y: height / 2 + r * Math.sin(a) };
  });
  for (var iter = 0; iter < 25; iter++) {
    var forces = positions.map(function () { return { fx: 0, fy: 0 }; });
    for (var i = 0; i < positions.length; i++) {
      for (var j = i + 1; j < positions.length; j++) {
        var dx = positions[j].x - positions[i].x, dy = positions[j].y - positions[i].y;
        var dist = Math.sqrt(dx * dx + dy * dy) || 1;
        var rep = 8000 / (dist * dist);
        forces[i].fx -= (dx / dist) * rep; forces[i].fy -= (dy / dist) * rep;
        forces[j].fx += (dx / dist) * rep; forces[j].fy += (dy / dist) * rep;
      }
    }
    edges.forEach(function (e) {
      var si = nodeIndex[e.source_node_id], ti = nodeIndex[e.target_node_id];
      if (si == null || ti == null) return;
      var dx = positions[ti].x - positions[si].x, dy = positions[ti].y - positions[si].y;
      var dist = Math.sqrt(dx * dx + dy * dy) || 1;
      var att = dist * 0.005;
      forces[si].fx += (dx / dist) * att; forces[si].fy += (dy / dist) * att;
      forces[ti].fx -= (dx / dist) * att; forces[ti].fy -= (dy / dist) * att;
    });
    positions.forEach(function (p, idx) {
      forces[idx].fx += (width / 2 - p.x) * 0.01; forces[idx].fy += (height / 2 - p.y) * 0.01;
    });
    positions.forEach(function (p, idx) {
      if (nodes[idx].position_x != null) return;
      p.x += Math.max(-20, Math.min(20, forces[idx].fx)); p.y += Math.max(-20, Math.min(20, forces[idx].fy));
      p.x = Math.max(80, Math.min(width - 80, p.x)); p.y = Math.max(50, Math.min(height - 50, p.y));
    });
  }
  return positions;
}

export function computeLayout(nodes, edges, width, height, mode) {
  if (nodes.length === 0) return [];
  var nodeIndex = {};
  nodes.forEach(function (n, i) { nodeIndex[n.node_id] = i; });
  if (mode === 'circular') return circularLayout(nodes, width, height);
  if (mode === 'hierarchical') return hierarchicalLayout(nodes, edges, nodeIndex, width, height);
  if (mode === 'manual') return manualLayout(nodes, width, height);
  return forceLayout(nodes, edges, nodeIndex, width, height);
}
